// action - state management
import {
  ACCOUNT_INITIALIZE,
  USER_ACCOUNT,
  LOGIN,
  LOGOUT,
  MENU_SELECT,
  PLAN_ACCOUNT,
  COMPANY,
  USER_IMAGE,
  TOUR_LOCATION,
} from "./actions";

export const initialState = {
  token: "",
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  sessionID: null,
  companyID: null,
  userPass: null,
  userData: null,
  menuItem: "Job Positions",
  planSelect: null,
  companyLogo: null,
  tour: null,
  endDate: null,
  userLogo: null,
  tourStatus: null,
  planName: null,
  customerId:null
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_INITIALIZE: {
      const {
        sessionID,
        isLoggedIn,
        user,
        token,
        userPass,
        companyID,
        partner_id,
        userId,
        customerId
      } = action.payload;
      return {
        ...state,
        isLoggedIn,
        isInitialized: true,
        companyID,
        partner_id,
        token,
        user,
        userId,
        sessionID,
        userPass,
        customerId
      };
    }
    case USER_ACCOUNT: {
      const { sessionID, userData, userLogo } = action.payload;
      return {
        ...state,
        sessionID,
        userData,
        userLogo,
      };
    }
    case USER_IMAGE: {
      const { userLogo } = action.payload;
      return {
        ...state,
        userLogo,
      };
    }
    case LOGIN: {
      const { sessionID, user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        sessionID,
        user,
      };
    }
    case LOGOUT: {
      return { ...initialState };
    }
    case TOUR_LOCATION: {
      const {tourStatus} = action.payload;
      return {
        ...state,
        tourStatus: tourStatus,
      };
    }

    case MENU_SELECT: {
      const { menuItem } = action.payload;
      return {
        ...state,
        menuItem: menuItem,
      };
    }
    case PLAN_ACCOUNT: {
      const { planSelect } = action.payload;
      return {
        ...state,
        planSelect,
      };
    }
    case COMPANY: {
      const { companyLogo, tour, companyName, endDate, planName } = action.payload;
      return {
        ...state,
        companyLogo,
        companyName,
        tour,
        endDate,
        planName,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
